import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const PageHeader = ({ eyebrow, title, subtitle, action }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Hide back button only on the root/dashboard route
  const showBack = location.pathname !== "/" && location.pathname !== "/dashboard";

  return (
    <div className="border-b border-[#E5E7EB] px-4 sm:px-8 py-6 sm:py-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 sm:gap-6 bg-white">
      <div className="min-w-0">
        {showBack && (
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold text-[#4B5563] hover:text-[#002FA7] mb-3"
            data-testid="page-back-button"
          >
            <ArrowLeft className="w-3 h-3" /> Back
          </button>
        )}
        {eyebrow && <div className="label-eyebrow mb-3">— {eyebrow}</div>}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-[#0a0a0a] break-words">{title}</h1>
        {subtitle && <p className="text-sm text-[#4B5563] mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
};

export const StatCard = ({ label, value, sub, accent = "primary", testid }) => {
  const accentColor = {
    primary: "#002FA7",
    success: "#10B981",
    warning: "#F59E0B",
    danger: "#EF4444",
  }[accent];
  return (
    <div className="flat-card p-5" data-testid={testid}>
      <div className="flex items-center justify-between mb-3">
        <div className="label-eyebrow">{label}</div>
        <div className="w-2 h-2" style={{ background: accentColor }} />
      </div>
      <div className="text-3xl font-black tracking-tight text-[#0a0a0a]">{value}</div>
      {sub && <div className="text-xs text-[#4B5563] mt-1">{sub}</div>}
    </div>
  );
};

export const StageBadge = ({ stage }) => {
  const colors = {
    "New Lead": "bg-[#F3F4F6] text-[#0a0a0a]",
    "Contacted": "bg-[#FEF3C7] text-[#92400E]",
    "Site Survey Scheduled": "bg-[#DBEAFE] text-[#1E40AF]",
    "Site Survey Completed": "bg-[#CCFBF1] text-[#0F766E]",
    "Proposal Sent": "bg-[#E0E7FF] text-[#3730A3]",
    "Negotiation": "bg-[#FCE7F3] text-[#9D174D]",
    "Won": "bg-[#D1FAE5] text-[#065F46]",
    "Lost": "bg-[#FEE2E2] text-[#991B1B]",
    "Dormant": "bg-[#E5E7EB] text-[#4B5563]",
    "Open": "bg-[#FEF3C7] text-[#92400E]",
    "Assigned": "bg-[#DBEAFE] text-[#1E40AF]",
    "In Progress": "bg-[#E0E7FF] text-[#3730A3]",
    "Resolved": "bg-[#D1FAE5] text-[#065F46]",
    "Closed": "bg-[#F3F4F6] text-[#4B5563]",
  };
  return (
    <span className={`inline-block px-2 py-0.5 text-[10px] uppercase tracking-wider font-bold ${colors[stage] || "bg-[#F3F4F6] text-[#0a0a0a]"}`}>
      {stage}
    </span>
  );
};
